export default __webpack_public_path__ + "static/media/cardcont3.2d8fb3eb.png";